import React, { useEffect } from 'react'
import buldingIcon from "../../assets/images/top-building-icon.svg";
import { useDispatch, useSelector } from 'react-redux';
import { propertyDetails } from '../../reducer/selfCheckinSlice';
import { setHomeNavigate } from '../../reducer/selfCheckinSlice';
import { useNavigate } from 'react-router-dom';

function CheckedIn() {

    const propertyDetailObj = useSelector(propertyDetails);
    const navigate = useNavigate();
    const dispatch = useDispatch();

    useEffect(() => {
        if (propertyDetailObj === undefined) {
            navigate("/Unauthorised")
        }

    }, [propertyDetailObj])

    return (
        <div>
            <div className='checkedIn-head'>
                Reservation already checked-in. Please contact us for more information
            </div>
            <div class="btn-fix-btm">
                <div className='checkedIn-ftr'>
                    <img src={buldingIcon} />
                    {/* <p>Royal Orchid Resorts and Convention Center</p> */}
                    <p>{propertyDetailObj?.Name}</p>
                </div>
                <button class="drk-blue-btn" onClick={() => {
                    dispatch(setHomeNavigate("FromHomePage"));
                    navigate("/HomeInfo");
                }}>Contact Us</button>
            </div>
        </div>
    )
}

export default CheckedIn;


